import { Injectable, signal } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class DataService {

  // References
  private isLoading = new Subject<boolean>();
  private isUserAuthenticated = new BehaviorSubject<boolean>(false);
  private generalNotificationMessage = new Subject<string>();
  userReference = '';
  private isLoginOffline = false;
  public nipSMSValidateFlagRegister = false;

  // Agentforce
  private _authStatus = signal<boolean>(false);
  public authStatus = this._authStatus.asReadonly();

  setIsLoading(loading: boolean) {
    this.isLoading.next(loading);
  }

  getIsLoading() {
    return this.isLoading.asObservable();
  }

  getGeneralNotificationMessage() {
    return this.generalNotificationMessage.asObservable();
  }

  setGeneralNotificationMessage(msg: string) {
    this.generalNotificationMessage.next(msg);
  }

  setUserAuthStatus(current: boolean) {
    this.isUserAuthenticated.next(current);
  }

  getInfoShow() {
    return false;
  }

  setInfoShow(info: boolean) {
    localStorage.setItem('info-message', JSON.stringify(info));
  }

  setIsLoginOffline(isLoginOffline: boolean) {
    this.isLoginOffline = isLoginOffline;
  }

  setAuthStatus(isAuthenticated: boolean){
    this._authStatus.set(isAuthenticated);
  }
}
